import { ConcreteEncodable } from "./ConcreteEncodable";

import { ExpiryDetailsImplEncoder } from "../../encoder/ExpiryDetailsImplEncoder";

import * as CubiqTS from "../../index";
import { ExpiryDetails } from "../ExpiryDetails";

export class ExpiryDetailsImpl extends ConcreteEncodable implements ExpiryDetails {
  public static enType: string = "com.bcdfx.model.ExpiryDetailsImpl";

  /*FID=1*/
  public expiryDate: string;
  /*FID=2*/
  public expiryTime: string;
  /*FID=3*/
  public timezone: string;
  /*FID=4*/
  public timeAlias: string;
  /*FID=5*/
  public dayOrder: boolean;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = ExpiryDetailsImplEncoder.Instance;
    this.setEncodableType(ExpiryDetailsImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "ExpiryDetailsImpl[" +
      "expiryDate=" +
      this.expiryDate +
      "expiryTime=" +
      this.expiryTime +
      "timezone=" +
      this.timezone +
      "timeAlias=" +
      this.timeAlias +
      "dayOrder=" +
      this.dayOrder +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
